import React from 'react';
import { Box, Grid, TextField, Button, Collapse } from '@mui/material';

const FulfillmentsLogFilters = ({ showFilter, meta, onFilterChange, onReset }) => {
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onFilterChange({ [name]: value, page: 1 });
    };

    return (
        <Collapse in={showFilter} timeout="auto" unmountOnExit>
            <div> {/* Shield node shielding parent block stack items dynamically */}
                <Box sx={{ p: 2.5, backgroundColor: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0', mb: 3, mt: 1 }}>
                    <Grid container spacing={2.5} alignItems="center">
                        <Grid item xs={12} sm={5}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                name="start_date"
                                label="Label Created Start Date"
                                InputLabelProps={{ shrink: true }}
                                value={meta.start_date || ''}
                                onChange={handleInputChange}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#FFFFFF' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' } }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                name="end_date"
                                label="Label Created End Date"
                                InputLabelProps={{ shrink: true }}
                                value={meta.end_date || ''}
                                onChange={handleInputChange}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#FFFFFF' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' } }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button 
                                onClick={onReset} 
                                variant="text" 
                                size="small" 
                                sx={{ textTransform: 'none', color: '#64748B', fontWeight: 700, fontSize: '13px', px: 2 }}
                            >
                                Reset Filters
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        </Collapse>
    );
};

export default FulfillmentsLogFilters;